<template>
  <span class="Emoji">
    <!--span v-html="utf"></span-->
    <slot>
    </slot>
  </span>
</template>

<script>
export default {
  name: 'BrickItem',
  data () {
    return {
    }
  },
  props: {
    codepoint: {type: String, default:"U+1F682"}
  },
  computed:{
    utf: function () {
      return "&#x" + this.codepoint.substr(2) + ";"
    }
  },
  methods: {
  },
  mounted: function () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


.Emoji{
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

</style>



// WEBPACK FOOTER //
// src/components/Emoji.vue